( function($) {
	/**
	 * Update the buying-limit dropdown button label with the selected user name.
	 */
	$( '.buying-limit-user-name' ).on( 'click',function() {
		const selectedName = $( this ).text();
		const dropdownContainer = $( this ).closest( '.portal-data-dropdown-container' );
		const triggerButton = dropdownContainer.find( 'button' );

		if( selectedName && triggerButton.length ) {
			triggerButton.text( selectedName );
		}
	} );
} )( jQuery );
